import React, { Component } from 'react';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import ClearCache from 'react-clear-cache';
import { Loader } from 'oxyrion-ui/lib';

import cookie from 'react-cookies';
import styled from 'styled-components';
import { rem } from 'polished';
import { BrowserRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect, actions } from './Store';
import Router from './Routes';
import { FlexBox } from './Components/ReusableComponents';
import NavBar from './Containers/NavBar';
import StoreSynchorizer from './Routes/StoreSynchorizer';
import Footer from './Containers/Footer';
import SidebarMenu from './Components/SideBarMenu';
import MobileMenu from './Components/MobileMenu';

const LoaderWrapper = styled(FlexBox)`
  margin: 29% 0;
`;

const Wrapper = styled.div`
  max-width: 100%;
  margin: auto;
  display: flex;
  ${({ theme }) => theme.media.m`
  padding: ${rem(0)} ${rem(0)} ${rem(0)} ${rem(0)};

`};
`;

const MainContainer = styled.div`
  width: 100%;
  margin-top: ${rem(150)};
  padding: 0;
  transition: all 0.3s linear;
  font-family: 'open sans';
  font-weight: 400;
  ${({ theme }) => theme.media.m`
  margin-top: ${rem(124)};
  margin-left: ${({ isMenuOpen }) => (isMenuOpen ? rem(230) : rem(35))};
  padding-left: ${rem(20)};
`};
`;

const SideBarWrapper = styled.div`
  display: none;
  z-index: 1000;
  position: fixed;
  ${({ theme }) => theme.media.m`
  margin-top: ${rem(125)};
  display: block;
`};
`;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      redirectTo: undefined,
      showPopup: false,
      isMenuOpen: localStorage.getItem('menuState') === 'true',
    };

    moment.locale('sk', {
      months: 'januara_februára_marca_apríla_mája_júna_jula_augusta_septembra_októbra_novembra_decembra'.split(
        '_',
      ),
    });

    this.handleOnClickLink = this.handleOnClickLink.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.onShoppingCartClick = this.onShoppingCartClick.bind(this);
  }

  async componentDidMount() {
    let activeCard = cookie.load('cart');
    const { carts } = this.props;

    try {
      if (!carts || !carts.find(c => c._id === activeCard)) {
        if (carts.length > 0 && carts[0] && carts[0]._id) {
          activeCard = carts[0]._id;
          cookie.save('cart', activeCard);
        } else {
          cookie.save('cart', carts.find(c => c.title === 'cart1'));
          this.setState({
            cartToLoad: carts.find(c => c.title === 'cart1')._id,
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  onShoppingCartClick(url) {
    this.setState({
      redirectTo: url,
    });
  }

  // getActiveIdFromMenuContent() {
  //   let id = null;

  //   this.props.menuItems.forEach(t => {
  //     if (!id) {
  //       if (t.url && window.location.pathname.includes(t.url)) {
  //         id = t._id;
  //       } else if (t.sections) {
  //         id =
  //           t.sections.find(s => window.location.pathname.includes(s.url)) &&
  //           t.sections.find(s => window.location.pathname.includes(s.url))._id;
  //       }
  //     }
  //   });

  //   return id;
  // }

  getLoggingOutContainer = () => {
    return (
      <LoaderWrapper>
        <Loader size="xl" />
      </LoaderWrapper>
    );
  };

  handleOnClickLink(item, activeSectionIds) {
    localStorage.setItem('activeSectionIds', JSON.stringify(activeSectionIds));

    if (item.url) {
      this.props.history.push(item.url);
      this.setState({
        redirectTo: item.url,
        visible: false,
      });
    }

    if (item.popup === 'import') {
      this.setState({
        showImport: true,
      });
    }
  }

  handleOpen() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  closePopup() {
    this.setState({
      showPopup: false,
    });
  }

  handleSearch(text) {
    this.setState({
      redirectTo: `/buy/catalog?q=${text}`,
      visible: false,
    });
  }

  cartChanged() {
    this.setState(this.state);
  }

  render() {
    const { loggingOut, firm, menuItems } = this.props;
    const { visible, cartToLoad, isMenuOpen } = this.state;

    const activeSectionIdsString = localStorage.getItem('activeSectionIds');
    const activeSectionIds =
      activeSectionIdsString &&
      activeSectionIdsString !== 'undefined' &&
      activeSectionIdsString !== 'null'
        ? JSON.parse(activeSectionIdsString)
        : [];

    return (
      <React.Fragment>
        <ClearCache auto>
          {() => (
            <React.Fragment>
              <Helmet>
                <title>
                  {window.location.hostname.includes('beta')
                    ? 'Oxyrion portal - BETA'
                    : 'Oxyrion portal'}
                </title>
              </Helmet>

              {loggingOut ? (
                this.getLoggingOutContainer()
              ) : (
                <React.Fragment>
                  <StoreSynchorizer>
                    <BrowserRouter>
                      <MobileMenu treeData={menuItems} />
                      <Wrapper>
                        <SideBarWrapper>
                          <SidebarMenu
                            sections={menuItems}
                            role={this.props.user.role}
                            height={`${window.innerHeight - 420}px`}
                            activeSectionIdsSaved={
                              activeSectionIds && activeSectionIds.length
                                ? activeSectionIds
                                : []
                            }
                            // setActiveIdTo={this.getActiveIdFromMenuContent()}
                            onClickLink={(
                              item,
                              activeSectionIds,
                              activeSubMenuId,
                            ) =>
                              this.handleOnClickLink(
                                item,
                                activeSectionIds,
                                activeSubMenuId,
                              )
                            }
                            visible={visible}
                            onMenuOpen={actualState => {
                              actions.setMenuState(actualState);
                              this.setState({
                                isMenuOpen: actualState,
                              });
                            }}
                          />
                        </SideBarWrapper>

                        <NavBar
                          cartToLoad={cartToLoad}
                          onCartChange={() => this.cartChanged()}
                        />
                        <MainContainer
                          isMenuOpen={isMenuOpen}
                          style={{ minHeight: `${window.innerHeight - 110}px` }}
                        >
                          <Router firm={firm} />
                        </MainContainer>
                      </Wrapper>

                      <Footer />
                    </BrowserRouter>
                  </StoreSynchorizer>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </ClearCache>
      </React.Fragment>
    );
  }
}

App.propTypes = {
  loggingOut: PropTypes.bool.isRequired,
  firm: PropTypes.string.isRequired,
  carts: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
    }),
  ),
};

App.defaultProps = {
  carts: [],
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js